/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Col_CodeInputs */

const vi_cdo_col_code = /** @type {(inputs: Cdo_Col_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã đơn`)
};

/**

* @param {Cdo_Col_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_col_code = /** @type {((inputs?: Cdo_Col_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Col_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_col_code(inputs)
});